var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.77778 3.94434C6.77778 3.39205 6.32677 2.93554 5.78274 3.03066C4.9943 3.16851 4.23936 3.46935 3.56782 3.91807C2.61767 4.55294 1.87711 5.4553 1.43981 6.51105C1.0025 7.5668 0.888082 8.72852 1.11102 9.8493C1.33396 10.9701 1.88424 11.9996 2.69227 12.8076C3.50031 13.6157 4.52981 14.1659 5.65059 14.3889C6.77137 14.6118 7.93309 14.4974 8.98884 14.0601C10.0446 13.6228 10.947 12.8822 11.5818 11.9321C12.0305 11.2605 12.3314 10.5056 12.4692 9.71715C12.5643 9.17312 12.1078 8.72211 11.5556 8.72211H8.27778C7.44935 8.72211 6.77778 8.05054 6.77778 7.22211V3.94434Z",
    fill: "#BE7637",
    stroke: "#BE7637"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94444 2.5C8.94444 1.94771 9.39643 1.49005 9.93794 1.59858C10.2595 1.66302 10.5747 1.75874 10.8791 1.88483C11.4925 2.1389 12.0498 2.51129 12.5193 2.98074C12.9887 3.45019 13.3611 4.00751 13.6152 4.62088C13.7413 4.92529 13.837 5.24054 13.9014 5.56206C14.01 6.10357 13.5523 6.55556 13 6.55556L9.14444 6.55556C9.03399 6.55556 8.94444 6.46601 8.94444 6.35556V2.5Z",
    fill: "#BE7637",
    stroke: "#BE7637",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.b0f3a0ea984ed943b4b3b7c6fb234a78.svg";
export { ForwardRef as ReactComponent };